import { COOKIE_LOCAL_STORAGE_ID } from "../../constants/cookieBanner";

export const deleteAllCookies = () => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });
};

export const setConsent = (value: "accepted" | "rejected") => {
  localStorage.setItem(COOKIE_LOCAL_STORAGE_ID, value);
  if (value === "rejected") {
    deleteAllCookies();
    // rimuovi o disattiva script terze parti
    // const iframes = document.querySelectorAll("iframe");
    // iframes.forEach((iframe) => {
    //   if (iframe.src.includes("google.com/maps")) iframe.remove();
    // });
    window.location.reload();
  } else {
    // se l'utente accetta, ricarichi per permettere caricamento dei cookie
    window.location.reload();
  }
};
